import { FontAwesomeIcon as RealFontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

const FontAwesomeIcon = ({ icon, ...props }: Props & any) => <RealFontAwesomeIcon icon={icon} {...props} />;

interface Props {
    icon: any
    className?: any
    onClick?: any
    style?: any
}

export default React.memo(FontAwesomeIcon);